import angular from 'angular';
import template from './self-video-frame-full.html';
import groupCallMobileDoctorActions from './actions/group-call/mobile-doctor-actions/mobile-doctor-actions';
import groupCallMobilePatientActions from './actions/group-call/mobile-patient-actions/mobile-patient-actions';
import oneToOneCallMobileDoctorActions from './actions/one-to-one/mobile-doctor-actions/mobile-doctor-actions';
import oneToOneCallMobilePatientActions from './actions/one-to-one/mobile-patient-actions/mobile-patient-actions';
import * as devices from '../../../../modules/devices';
import * as call from '../../../../modules/call';
import * as localMedia from '../../../../modules/local-media';
class SelfVideoFrameController {
    constructor($scope, VideoProviderFactory, $element, downgradeCallStateService, $ngRedux) {
        this.$scope = $scope;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$element = $element;
        this.downgradeCallStateService = downgradeCallStateService;
        this.$ngRedux = $ngRedux;
        this.selfPublisherErrorVariant = call.constants.CallFrameVariant.Full;
        this.patientModalOpen = false;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
        VideoProviderFactory.decorateScope(this);
    }
    $onInit() {
        this.$scope.$watch('$ctrl.withVideo', () => {
            if (this.withVideo) {
                this.$element[0]
                    .getElementsByClassName('call-frames__append-video')[0]
                    .appendChild(document.getElementById(this.videoPublisherId));
            }
        });
    }
    isShownCallPlaceholder() {
        return ((this.isVideoDisabled ||
            !this.withVideo ||
            !this.hasMediaAccess ||
            this.hasMicrophoneAccessOnly) &&
            !this.downgradeCallStateService.isShownDowngradeFrame());
    }
    mapStateToThis(state) {
        return {
            hasMediaAccess: devices.selectors.hasMediaAccess(state),
            hasMicrophoneAccessOnly: devices.selectors.hasMicrophoneAccessOnly(state),
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const selfVideoFrameComponent = {
    template,
    bindings: {
        withVideo: '<',
        username: '<',
        disabled: '<',
        isInGroupCall: '<',
        isVideoDisabled: '<',
        videoPublisherId: '<',
        avatarPicture: '<',
        hasSelfPublisherError: '<',
    },
    controller: SelfVideoFrameController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrameFullComponent', [
    groupCallMobileDoctorActions,
    groupCallMobilePatientActions,
    oneToOneCallMobileDoctorActions,
    oneToOneCallMobilePatientActions,
])
    .component('selfVideoFrameFull', selfVideoFrameComponent).name;
